export default __webpack_public_path__ + "static/media/fon-bg-top.2564b0ff.jpg";